
if (!customElements.get('product-card-gallery')) {
  
  
  const ARROW_QUERY = 'only screen and (min-width: 1000px) and (hover: hover)';
  const SHOW_TIMEOUT = 2000;

  customElements.define(
    'product-card-gallery',
    class ProductCardGallery extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-pcs-shot-nav]');
        this.prevBtn = this.querySelector('[data-pcs-shot-prev]');
        this.nextBtn = this.querySelector('[data-pcs-shot-next]');
        if (!this.nav || !this.prevBtn || !this.nextBtn) return;

        
        
        this.scope = this.querySelector('[data-pcs-shot-group]:not([hidden])') || this;
        this.shots = Array.from(this.scope.querySelectorAll('[data-pcs-shot]'));

        this.index = 0;
        this.pendingIndex = null;
        
        
        this.showToken = this.showToken || 0;
        this.handlePrev = this.step.bind(this, -1);
        this.handleNext = this.step.bind(this, 1);

        this.prevBtn.addEventListener('click', this.handlePrev);
        this.nextBtn.addEventListener('click', this.handleNext);

        this.updateNav();

        
        
        this.arrowQuery = window.matchMedia(ARROW_QUERY);
        this.handleQueryChange = this.watchForPreload.bind(this);
        this.arrowQuery.addEventListener('change', this.handleQueryChange);
        this.watchForPreload();
      }

      disconnectedCallback() {
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
        if (!this.arrowQuery) return;

        this.arrowQuery.removeEventListener('change', this.handleQueryChange);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        
        
        this.showToken += 1;
      }

      
      watchForPreload() {
        if (this.preloaded || this.observer || !this.arrowQuery.matches) return;
        if (!('IntersectionObserver' in window)) {
          this.preloaded = true;
          this.loadShot(this.shots[1], 'low');
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.observer = null;
          this.preloaded = true;
          this.loadShot(this.shots[1], 'low');
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }

      
      loadShot(shot, priority) {
        if (!shot) return;
        shot.querySelectorAll('img[data-manual-src]').forEach((img) => {
          img.loading = 'eager';
          if (priority) img.fetchPriority = priority;
          if (img.dataset.manualSrcset) img.srcset = img.dataset.manualSrcset;
          img.src = img.dataset.manualSrc;
          img.removeAttribute('data-manual-src');
          img.removeAttribute('data-manual-srcset');
        });
      }

      
      useGroup(group) {
        if (!group || !this.prevBtn) return;

        this.scope = group;
        this.shots = Array.from(group.querySelectorAll('[data-pcs-shot]'));
        this.index = 0;
        this.pendingIndex = null;
        this.showToken += 1;
        this.shots.forEach((shot, i) => {
          shot.classList.toggle('product-card-slider__shot--active', i === 0);
        });
        this.updateNav();

        if (this.arrowQuery && this.arrowQuery.matches) this.loadShot(this.shots[1], 'low');
      }

      
      updateNav() {
        if (this.nav) this.nav.hidden = this.shots.length < 2;
      }

      
      step(delta, evt) {
        
        
        evt.preventDefault();
        evt.stopPropagation();

        
        
        
        if (this.shots.length < 2) return;

        
        
        const count = this.shots.length;
        const from = this.pendingIndex === null ? this.index : this.pendingIndex;
        const target = ((from + delta) % count + count) % count;

        
        
        
        const shots = this.shots;
        this.loadShot(shots[target], 'high');
        this.show(target).then(() => this.preloadAhead(shots, target, delta));
      }

      
      async preloadAhead(shots, from, delta) {
        if (this.preloadingAhead === shots) return;
        this.preloadingAhead = shots;

        const count = shots.length;
        for (let k = 1; k < count; k += 1) {
          if (!this.isConnected || shots !== this.shots) break;
          const shot = shots[((from + delta * k) % count + count) % count];
          const img = shot.querySelector('img[data-manual-src]');
          if (!img) continue;
          this.loadShot(shot, 'low');
          if (typeof img.decode === 'function') await img.decode().catch(() => {});
        }

        if (this.preloadingAhead === shots) this.preloadingAhead = null;
      }

      
      show(target) {
        const token = ++this.showToken;
        this.pendingIndex = target;

        const img = this.shots[target].querySelector('img');
        const ready = img && typeof img.decode === 'function'
          ? img.decode().catch(() => {})
          : Promise.resolve();
        const timeout = new Promise((resolve) => setTimeout(resolve, SHOW_TIMEOUT));

        return Promise.race([ready, timeout]).then(() => {
          if (token !== this.showToken) return;
          this.index = target;
          this.pendingIndex = null;
          this.shots.forEach((shot, i) => {
            shot.classList.toggle('product-card-slider__shot--active', i === target);
          });
        });
      }
    }
  );
}
